import 'whatwg-fetch';
import {decryptUserData,encryptUserData} from './security/informationCodingSecurity';
import { getAuthApp } from './security/authApp';
import { decrypt } from './security/encryptorHandlerSecurity';

const serverURL = process.env.REACT_APP_SERVERURL;

const handleResponse = (response) => {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
};

class reclamaPremioService {

  static loadListReclamoPremio(body) {

    const url = `${serverURL}/api/Users/etn/reclama-premio`;
    console.log('loadListReclamoPremio', body);
    const data = JSON.stringify( {body: {...body}}, null, 2);

    return fetch(url, {
      method: 'POST',
      body: data,
      headers: new Headers({
        'content-type': 'application/json',
        'Authorization': getAuthApp()
      })
    })
      .then(handleResponse)
      .then(response => response)
      .catch(error => {
        return Promise.reject(error);
      });
  }

}

export default reclamaPremioService;
